// Individual field validators — each returns true (has error) or false (valid)

export function validateRequired(value) {
  return !value || !value.toString().trim();
}

export function validateMinLength(value, min) {
  return !value || value.toString().trim().length < min;
}

export function validateMaxLength(value, max) {
  return value && value.toString().trim().length > max;
}

export function validateEmail(value) {
  if (!value || !value.toString().trim()) return true;
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return !pattern.test(value.toString().trim());
}

export function validatePhone(value) {
  if (!value || !value.toString().trim()) return true;
  const pattern = /^\d{10}$/;
  return !pattern.test(value.toString().trim());
}

export function validatePostalCode(value) {
  if (!value || !value.toString().trim()) return true;
  const pattern = /^\d{6}$/;
  return !pattern.test(value.toString().trim());
}

// Composite validators for checkout sections
// Return an object where truthy values indicate errors (matching validationTrace shape)

export function validateUserDetails(userDetails) {
  const errors = {};
  if (validateRequired(userDetails.first_name)) {
    errors.first_name = "Please enter your first name.";
  } else if (validateMinLength(userDetails.first_name, 2)) {
    errors.first_name = "First name must be at least 2 characters.";
  } else if (validateMaxLength(userDetails.first_name, 50)) {
    errors.first_name = "First name must not exceed 50 characters.";
  }

  if (validateRequired(userDetails.last_name)) {
    errors.last_name = "Please enter your last name.";
  } else if (validateMinLength(userDetails.last_name, 1)) {
    errors.last_name = "Last name must be at least 1 character.";
  } else if (validateMaxLength(userDetails.last_name, 50)) {
    errors.last_name = "Last name must not exceed 50 characters.";
  }

  if (validateRequired(userDetails.email)) {
    errors.email = "Please enter your email address.";
  } else if (validateEmail(userDetails.email)) {
    errors.email = "Please enter a valid email address.";
  }

  if (validateRequired(userDetails.phone)) {
    errors.phone = "Please enter your phone number.";
  } else if (validatePhone(userDetails.phone)) {
    errors.phone = "Please enter a valid 10-digit phone number.";
  }
  return errors;
}

export function validateShippingAddress(shippingDetails) {
  const errors = {};
  if (validateRequired(shippingDetails.address_address)) {
    errors.address_address = "Please specify an address for shipping.";
  } else if (validateMinLength(shippingDetails.address_address, 3)) {
    errors.address_address = "Address must be at least 3 characters.";
  } else if (validateMaxLength(shippingDetails.address_address, 200)) {
    errors.address_address = "Address must not exceed 200 characters.";
  }
  if (validateRequired(shippingDetails.address_zipcode)) {
    errors.address_zipcode = "Please enter your pin code.";
  } else if (validatePostalCode(shippingDetails.address_zipcode)) {
    errors.address_zipcode = "Please enter a valid pin code.";
  }

  if (validateRequired(shippingDetails.address_city)) {
    errors.address_city = "Please enter your city.";
  } else if (validateMinLength(shippingDetails.address_city, 2)) {
    errors.address_city = "City must be at least 2 characters.";
  } else if (validateMaxLength(shippingDetails.address_city, 50)) {
    errors.address_city = "City must not exceed 50 characters.";
  }

  if (validateRequired(shippingDetails.address_state)) {
    errors.address_state = "Please enter your state.";
  } else if (validateMinLength(shippingDetails.address_state, 2)) {
    errors.address_state = "State must be at least 2 characters.";
  } else if (validateMaxLength(shippingDetails.address_state, 50)) {
    errors.address_state = "State must not exceed 50 characters.";
  }

  if (validateRequired(shippingDetails.address_country)) {
    errors.address_country = "Please enter your country.";
  } else if (validateMinLength(shippingDetails.address_country, 2)) {
    errors.address_country = "Country must be at least 2 characters.";
  } else if (validateMaxLength(shippingDetails.address_country, 50)) {
    errors.address_country = "Country must not exceed 50 characters.";
  }
  return errors;
}

export function validateBillingAddress(billingDetails) {
  const errors = {};
  if (validateRequired(billingDetails.address_address)) {
    errors.address_address = "Please specify an address for billing.";
  } else if (validateMinLength(billingDetails.address_address, 3)) {
    errors.address_address = "Address must be at least 3 characters.";
  } else if (validateMaxLength(billingDetails.address_address, 200)) {
    errors.address_address = "Address must not exceed 200 characters.";
  }
  if (validateRequired(billingDetails.address_zipcode)) {
    errors.address_zipcode = "Please enter your pin code.";
  } else if (validatePostalCode(billingDetails.address_zipcode)) {
    errors.address_zipcode = "Please enter a valid pin code.";
  }

  if (validateRequired(billingDetails.address_city)) {
    errors.address_city = "Please enter your city.";
  } else if (validateMinLength(billingDetails.address_city, 2)) {
    errors.address_city = "City must be at least 2 characters.";
  } else if (validateMaxLength(billingDetails.address_city, 50)) {
    errors.address_city = "City must not exceed 50 characters.";
  }

  if (validateRequired(billingDetails.address_state)) {
    errors.address_state = "Please enter your state.";
  } else if (validateMinLength(billingDetails.address_state, 2)) {
    errors.address_state = "State must be at least 2 characters.";
  } else if (validateMaxLength(billingDetails.address_state, 50)) {
    errors.address_state = "State must not exceed 50 characters.";
  }

  if (validateRequired(billingDetails.address_country)) {
    errors.address_country = "Please enter your country.";
  } else if (validateMinLength(billingDetails.address_country, 2)) {
    errors.address_country = "Country must be at least 2 characters.";
  } else if (validateMaxLength(billingDetails.address_country, 50)) {
    errors.address_country = "Country must not exceed 50 characters.";
  }
  return errors;
}
